import stakeIcon from "../images/stakeIcon.png";
import graph from "../images/singleGraph.svg";
import { FaChevronUp } from "react-icons/fa6";
import { Link } from "react-router-dom";

const StakePosition = () => {
  return (
    <div className="">
      <div className="flex items-center my-5 ml-10">
        <img className="w-[82px]" src={stakeIcon} alt="Swap Gold" />
        <div className="ml-2">
          <h3 className="text-2xl text-yellow-400 font-semibold">
            Stake $SGOLD Token
          </h3>
          <p className="text-lg font-semibold">
            Stake your $SGOLD Tokens and Earn Money{" "}
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center p-5 relative  w-full h-auto ">
        <div>
          <Link to={"/stakePosition"} className= "inline-block m-2 px-6 py-3 font-bold text-yellow-400  hover:text-yellow-300 rounded-3xl transition-all duration-300  shadow-lg  transform origin-center">
            Current Positions
          </Link>
          <Link to={"/stake"} className="inline-block m-2 px-6 py-3 font-bold text-gray-900 bg-yellow-400 rounded-3xl transition-all duration-300 hover:bg-yellow-300 hover:scale-110 shadow-lg hover:shadow-yellow-500/30 transform origin-center">
            New Position
          </Link>
        </div>
        <div className="flex flex-wrap w-full items-center justify-center">
          <div className="flex flex-col w-[130px] md:w-[200px] items-center m-2 justify-center">
            <img src={graph} alt="Graph" />
            <p className=" text-center">
              Cost: $1500 <br />
              Current: $1870 <br />{" "}
              <div>
                PNL:<span className="text-green-500">+370 (%20)</span>
              </div>
            </p>
          </div>
          <div className="flex flex-col w-[130px] md:w-[200px] items-center m-2 justify-center">
            <img src={graph} alt="Graph" />
            <p className=" text-center">
              Cost: $1500 <br />
              Current: $1870 <br />{" "}
              <div>
                PNL:<span className="text-green-500">+370 (%20)</span>
              </div>
            </p>
          </div>
          <div className="flex flex-col w-[130px] md:w-[200px] items-center m-2 justify-center">
            <img src={graph} alt="Graph" />
            <p className=" text-center">
              Cost: $1500 <br />
              Current: $1870 <br />{" "}
              <div>
                PNL:<span className="text-green-500">+370 (%20)</span>
              </div>
            </p>
          </div>
          <div className="flex flex-col w-[130px] md:w-[200px] items-center m-2 justify-center">
            <img src={graph} alt="Graph" />
            <p className=" text-center">
              Cost: $1500 <br />
              Current: $1870 <br />{" "}
              <div>
                PNL:<span className="text-green-500">+370 (%20)</span>
              </div>
            </p>
          </div>
        </div>
        <h3 className="text-yellow-400 text-center mt-3 font-semibold text-lg flex">
          Gold = $2,671.37
          <span className="text-green-500 text-center flex items-center mx-1">
            <FaChevronUp /> %0.54
          </span>
        </h3>
      </div>
    </div>
  );
};

export default StakePosition;
